















import { NAME as INTERIER_NAME } from '@/modules/ciselnik/dilenske/interier/constants';
import { openSelectList } from '@/main/router/routerPath';
// eslint-disable-next-line no-unused-vars
import { Row } from '@/main/utils/table';

import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		mutationName: { type: String, required: true },
		validationPropertyValue: { type: String },
		validationPropertyText: { type: String },
	},
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'BARVA_KOD_OBJED',
		};
	},
	methods: {
		async openBarvaSelect(selection: (row: Row) => void) {
			await openSelectList(NAME, {
				afterRowSelection: selection,
				filter: this.filter,
			});
			this.setPageManagerMapper();
		},
		async openInterierSelect() {
			await openSelectList(INTERIER_NAME, {
				afterRowSelection: this.selectedBarvaInterier,
				filter: this.filter,
			});
			this.setPageManagerMapper();
		},
		selectedBarva({ row }: { row: Record<string, any> }) {
			const data = this.dbToBaseMapper(row);
			this.mapData({ data, position: 1 });
		},
		selectedBarvaLaku({ row }: { row: Record<string, any> }) {
			const data = this.dbToBaseMapper(row);
			this.mapData({ data, position: 2 });
		},
		selectedBarvaInterier({ row }: { row: Record<string, any> }) {
			const data = { value: row.INTERIER_KOD_OBJED, text: row[this.textFieldName] };
			this.mapData({ data, position: 3 });
		},
		dbToBaseMapper(data: Record<string, any>) {
			return { value: data[this.valueFieldName], text: data[this.textFieldName] };
		},
		getMutatedColor(oldColor: string, newColor: string, position: number) {
			// eslint-disable-next-line no-param-reassign
			newColor.length === 1 && (newColor += ' ');

			const colorLength = oldColor ? oldColor.length : 0;

			const color0 = colorLength >= 2 ? oldColor.slice(0, 2) : '__';
			const color1 = colorLength >= 4 ? oldColor.slice(2, 4) : '__';
			const color2 = colorLength >= 6 ? oldColor.slice(4) : '__';

			switch (position) {
				case 1:
					return `${newColor}${color1}${color2}`;
				case 2:
					return `${color0}${newColor}${color2}`;
				case 3:
					return `${color0}${color1}${newColor}`;
				default:
					return newColor;
			}
		},
		mapData({ data, position }: { data: { value: string; text: string }; position: number }) {
			const value = this.getMutatedColor(this.value as string, data.value, position);
			const text = position === 1 ? data.text : this.text;

			this.$store.commit(this.mutationName, { data: { value, text } });
		},
	},
});
